import { useEffect, useState } from "react";
import { cn } from "./cn";

/**
 * ISKELET YUKLEYICI
 *
 * ================================================================
 * HIZLI YUKLEMEDE HIC GORUNMUYOR
 * ================================================================
 * Yanip sonen bir iskelet, hic iskelet olmamasindan KOTU: goz bir
 * seyin belirip kaybolmasini "titreme" diye okuyor ve arayuz
 * kararsiz gorunuyor. Onbellekten gelen bir liste 30ms'de hazir
 * oluyor; o 30ms icin gri kutular cizmek zarar.
 *
 * Bu yuzden iskelet KENDI GORUNMESINI GECIKTIRIYOR. Gecikmeyi her
 * cagirana birakmak, birinin unutmasi demekti — ve unutuldugu yerde
 * ariza "titriyor" gibi belirsiz bir sikayete donusurdu.
 *
 * 160ms secildi: insan gozu bunun altindaki bir bekleyisi zaten
 * "anlik" sayiyor, ustundekini "bekleme" sayiyor.
 *
 * ================================================================
 * SEKLI TAKLIT EDIYOR, KUTU DEGIL
 * ================================================================
 * Genel bir gri dikdortgen, "Yukleniyor..." yazisindan cok az iyi.
 * Iskeletin degeri gelecek icerigin DUZENINI onceden gostermesinde:
 * kullanici sayfa yerlesmeden once nereye bakacagini ogreniyor ve
 * icerik geldiginde goz ziplamak zorunda kalmiyor.
 *
 * O yuzden `satir` sayisi ve `baslikli` gibi kucuk ayarlar var;
 * ekranlar gelecek icerige benzeyen bir iskelet kurabiliyor.
 */

const GECIKME_MS = 160;

export interface IskeletProps {
  /** Kac satirlik bir liste bekleniyor */
  satir?: number;
  /** Ustte daha genis bir baslik cubugu olsun mu */
  baslikli?: boolean;
  /** Ekran okuyucuya duyurulacak metin */
  etiket?: string;
  className?: string;
}

export function Iskelet({
  satir = 3,
  baslikli = false,
  etiket = "Yükleniyor",
  className,
}: IskeletProps) {
  const [gorunur, setGorunur] = useState(false);

  useEffect(() => {
    const z = setTimeout(() => setGorunur(true), GECIKME_MS);
    return () => clearTimeout(z);
  }, []);

  /**
   * Gecikme boyunca DOM'da bir sey var ama gorunmuyor —
   * `aria-busy` yine de duyuruluyor.
   *
   * Bos donseydik ekran okuyucu kullanicisi ilk 160ms'de "sayfa
   * bos" bilgisini alirdi; gorme engelli kullanici icin o an
   * "burada bir sey yok" demek.
   */
  if (!gorunur) {
    return <span role="status" aria-busy="true" className="sr-only" />;
  }

  return (
    <div role="status" aria-busy="true" className={cn("belir flex flex-col gap-2", className)}>
      <span className="sr-only">{etiket}</span>

      {baslikli && <span aria-hidden="true" className="bg-notr-200/70 h-5 w-40 rounded" />}

      {Array.from({ length: satir }, (_, i) => (
        <span
          key={i}
          aria-hidden="true"
          className={cn(
            "bg-notr-200/70 h-4 rounded",
            /*
              Satir genislikleri BILEREK esit degil. Esit uzunlukta
              gri cubuklar bir tabloya benziyor ve kullanici onlari
              icerik saniyor; degisken uzunluk "bu henuz metin degil"
              bilgisini veriyor.
            */
            i % 3 === 0 ? "w-full" : i % 3 === 1 ? "w-11/12" : "w-4/5",
          )}
        />
      ))}
    </div>
  );
}

/**
 * Kart bicimli iskelet — kart izgarasi bekleyen ekranlar icin.
 */
export function IskeletKart({ adet = 3 }: { adet?: number }) {
  return (
    <div className="flex flex-col gap-3">
      {Array.from({ length: adet }, (_, i) => (
        <div key={i} className="rounded-kart border-notr-200 border bg-white p-4">
          <Iskelet satir={2} baslikli />
        </div>
      ))}
    </div>
  );
}
